import Stack from '@mui/material/Stack'
import { useFormContext } from 'react-hook-form'

import TextField from '@/Components/Common/Inputs/TextField'

const PasswordFormFields: React.FC = () => {
  const {
    register,
    watch,
    formState: { errors }
  } = useFormContext()
  const password = watch('password')
  return (
    <Stack gap={2}>
      <TextField
        autoFocus
        {...register('password', {
          minLength: {
            value: 8,
            message: 'Password must be at least 8 characters'
          },
          maxLength: {
            value: 128,
            message: 'Password must be at most 128 characters'
          }
        })}
        label="Password"
        type="password"
        autoComplete="new-password"
        fullWidth
        required
        error={!!errors.password}
        helperText={errors.password?.message as string}
      />
      <TextField
        {...register('password_confirmation', {
          validate: (value) => value === password || 'Passwords do not match'
        })}
        label="Confirm password"
        type="password"
        autoComplete="new-password"
        fullWidth
        name="password_confirmation"
        required
        error={!!errors.password_confirmation}
        helperText={errors.password_confirmation?.message as string}
      />
    </Stack>
  )
}

export default PasswordFormFields
